import React, { Component } from 'react';
import './progress_ball.css'

export default class ProgressBall extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_step:props.step
        }   
    }

    render() {
        return (
            <div className='progress'>
                <div className={`element ${ this.state.current_step === 1 ?"active":null}`}>1</div>
                <div className={`element ${ this.state.current_step === 2 ?"active":null}`}>2</div>
                <div className={`element ${ this.state.current_step === 3 ?"active":null}`}>3</div>
            </div>
        );
    }
}